const imgSrc = require('../../../assets/image/login_scan.png')

export default {
  name: 'GoodsCardImage',

  parent: 'GoodsCard',

  data () {
    return {
      src: ''
    }
  },

  render () {
    return (
      <div class="image-container">
        <img src={imgSrc} class="image_ad" />
      </div>
    )
  }
}